module.exports = __webpack_public_path__ + "img/syukyaku-landing-pa005.704ea017.png";